import type { Person } from "@pagerless/schema";

/**
 * Should this browser set the account's time zone? Only an owner, only to a zone the browser knows,
 * and only when the account has none or a different one. Returns the zone to save, or null.
 */
export function zoneToSave(n: {
  role: Person["role"];
  accountZone: string | null;
  browserZone: string | undefined;
}): string | null {
  if (n.role !== "owner") return null;
  const zone = n.browserZone?.trim();
  if (!zone) return null;
  return zone === n.accountZone ? null : zone;
}

/** The browser's IANA zone, e.g. "Asia/Kolkata"; undefined when the runtime can't say. */
export function browserTimeZone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}
